import * as madnes from "../../framework/src/engine/madnes/madnes";
import {madnes_set_win_factors} from "../../framework/src/engine/madnes/madnes";
import {set_show_money_pos_y} from "../../framework/src/engine/madnes/madnes_anims";
import {he} from "../../framework/src/engine/madnes/madnes_variables";
import {madnes_set_sprite} from "../../framework/src/engine/madnes/madnes";
import {madnes_set_audio_volume, madnes_set_default_volume} from "../../framework/src/engine/madnes/madnes_audio";
import {ico_wi} from "../../framework/src/engine/madnes/madnes_variables";
import {ico_he} from "../../framework/src/engine/madnes/madnes_variables";
import {wanted_end_round_recalced, wanted_rotate_run} from "../wanted_core";
import {
    openinfo,
    wanted_infomenu_close, wanted_infomenu_init,
    wanted_infomenu_left,
    wanted_infomenu_open,
    wanted_infomenu_right, wanted_infomenu_update,
    wanted_print_desk
} from "../wanted_reels";
import {wanted_print_reels} from "../wanted_core_printer";
import {WALLET_EVENTS} from "../../framework/src/wallet/Wallet";
import {GAME_EVENTS} from "../../framework/src/game/gameEvents";

export const infotexts_languages = [
    "cs", "en", "hr", "ro", "pl", "de", "fi", "no", "ru", "es", "sr", "sv", "tr", "sk", "pt", "es-mx", "bg", "fr", "it", "lt"
];

export function initGame(gameset) {

    set_show_money_pos_y(he / 2 - 20);

    madnes.set_ico_size(222, 202);
    madnes_set_win_factors(25, 50, 125);
    // // madnes_set_native_sceen_size(1280, 720);
    //

    madnes_set_sprite('_sprite', ico_wi, ico_he);

    madnes_set_sprite('_blur', ico_wi, ico_he);

    madnes_set_sprite('wheel_sprite', 580, 580);
    madnes_set_sprite('shot_sprite', 154, 126);
    madnes_set_sprite('colt_sprite', 188, 534);
    madnes_set_sprite('bonus_Winfont_Big', 64, 108);
    madnes_set_sprite('bonus_Winfont_Small', 64, 108);
    madnes_set_sprite('big-win_Start_sprite', 1280 / 2, 800 / 2);
    madnes_set_sprite('spark_sprite_', 306, 306);
    madnes_set_sprite('intro_sprite_', 1280 / 2, 800 / 2);

    madnes_set_default_volume(0.8);
    madnes_set_audio_volume("BACKGROUND", 0.6);
}

export function notify(eventName, data, prevData) {

    switch(eventName) {

        case GAME_EVENTS.GAME_FREESPIN_END:
        case GAME_EVENTS.GAME_END_ROUND_FREESPINS:
            freespins_end_round(eventName, data);
            break;

        case GAME_EVENTS.GAME_END_ROUND_RECALCED:
            end_round_recalced(eventName, data);
            break;

        case WALLET_EVENTS.WALLET_ON_SET_BET:
            // show_all_lines();
            infomenu_update();
            break;

        // case ACTION_EVENTS.ACTION_BETMENU_OPEN:
        //     soe_lines_open();
        //     break;

        // //case ACTION_EVENTS.ACTION_BETMENU_CLOSE:
        //     soe_lines_close(data);
        //     break;

        // case UISLIDER_EVENTS.UISLIDER_CHANGE_LINES:
        //     // soe_lines_change();
        //     break;
    }
}



export function on_set_bet() {
    infomenu_update();
}

export function initLoad() {}

export function game_start() {
    wanted_rotate_run();
}

export function print_desk() {
    wanted_print_desk();
}

export function print_reels() {
    wanted_print_reels();
}

export function infomenu_init() {
    wanted_infomenu_init();
}

export function infomenu_open() {
    infomenu_update();
    wanted_infomenu_open();
}

export function infomenu_close() {
    wanted_infomenu_close();
}

export function is_info_open() {
    return openinfo;
}

export function infomenu_left() {
    wanted_infomenu_left();
}

export function infomenu_right() {
    wanted_infomenu_right();
}

export function infomenu_update() {
    wanted_infomenu_update();
}

export function end_round_recalced(eventName, {autostart}) {
    wanted_end_round_recalced();

    if(!autostart) {
        end_round_no_autostart();
    }
}

export function end_round_no_autostart() {
}

export function freespins_end_round(eventName, {ended}) {}

export function get_preinfo() {}

export function preinfo_close() {}
